<app-pre-loader *ngIf="IsLoadingResults"></app-pre-loader>

<div class="content-wrapper">

    <!-- Default box -->
    <div class="box">

        <form (ngSubmit)="onSubmit()" [formGroup]="TQLeaderRequistion">
            <mat-card class="btnCard">
                <mat-card-actions>
                    <button type="button" class="btn-primary1" (click)="SendToTQOrET(sendTQ_ET,PendingWithTQTeam)"
                        mat-stroked-button>Send to TQ Approver</button>
                    <button type="button" class="btn-primary1" (click)="SendToTQOrET(sendTQ_ET,ReturnByTQLLeader)"
                        mat-stroked-button>Send To
                        ET</button>
                    <button class="btn-primary1" mat-stroked-button type="button" (click)="Exit()">Exit</button>
                </mat-card-actions>
            </mat-card>
            <!--13. Incorrect Status Update and Unauthorized Save as Draft Option for TQ Leader-->
            <mat-card class="card2">
                <div class="row" style="color:green;">
                    <div class="col-md-5"><b>Request No : </b>{{GTCNo}}</div>
                    <div class="col-md-5"><b>Status :</b> {{FormStatusName | json}}</div>
                </div>
            </mat-card>
            <div class=" row">
                <div class="mb-3 col-md-6">
                    <u><b>Section A</b></u>
                </div>
            </div>
            <div class="row">
                <div class="mb-3 col-md-6">
                    <label>Client Name</label>
                    <input type="text" readonly class="form-control" formControlName="ClientName" />
                </div>
                <div class="mb-3 col-md-6">
                    <label>Engagement Partner Name</label>
                    <input type="text" readonly class="form-control" formControlName="EngPartnerName" />
                </div>
            </div>
            <div class="row">
                <div class="mb-3 col-md-6">
                    <label>Expected Fees From Engagement</label>
                    <input type="text" readonly class="form-control" formControlName="ExpectedFeesFromClient" />
                </div>
                <div class="mb-3 col-md-6">
                    <label>Is this an independence restricted client ?</label>
                    <div class="input-group radio-div">
                        <mat-radio-group formControlName="IsIndependenceRestrictedClient">
                            <mat-radio-button disabled value="1">Yes</mat-radio-button>
                            <mat-radio-button disabled value="2">No</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
            <div class=" row">
                <div class="mb-3 col-md-6">
                    <u><b>Section B</b></u>
                </div>
            </div>
            <div class="row">
                <div class="mb-3 col-md-12">
                    <label>Brief scope of Work</label>
                    <textarea class="form-control" readonly formControlName="ScopeOfWorkInBrief"
                        style="resize:none; height: 80px; border-color: black;"></textarea>
                </div>
            </div>
            <div class="row">
                <div class="mb-3 col-md-12">
                    <label>Level Of Push Back</label>
                    <textarea class="form-control" readonly formControlName="PushBackDone"
                        style="resize:none; height: 80px; border-color: black;"></textarea>
                </div>
            </div>
            <div class="row">
                <div class="mb-3 col-md-12">
                    <label>TQ Comments</label>
                    <textarea class="form-control" readonly formControlName="SendToTQLWithReasons"
                        style="resize:none; height: 80px; border-color: black;"></textarea>
                </div>
            </div>
            <div class=" row">
                <div class="mb-3 col-md-6">
                    <u><b>Section C</b></u>
                </div>
            </div>
        </form>
        <!-- <div class="row" *ngIf="IsFilterShown">
                    <div class="filterDiv">
                        <form  [formGroup]="formGroup">
                            <p-dropdown formControlName="selectedCity" 
                            placeholder="Select Filter" 
                           [style]="{'border-bottom':'4px solid #ffe600','border-radius':'4px'}"
                            (onChange)="onFilterchange($event)"
                            [options]="values" optionLabel="name"></p-dropdown>
                        </form>
                    </div>
                 
                </div> -->

        <div class="row">
            <div class="mb-3 col-sm-12" *ngFor="let dataMain of ClauseViewList">
                <div class="cardSearchMain">
                    <div class="card-headerMain form-control" data-bs-toggle="collapse"
                        attr.href="#{{'ABCD' + dataMain.GtcID}}" role="button" aria-expanded="false"
                        attr.aria-controls="#{{'ABCD' + dataMain.GtcID}}">
                        <header class="panel-heading">
                            <Label class="panel-title">{{dataMain.ClauseNo}}
                            </Label>
                            <span style="float:right"> <i class="pi pi-arrow-down"></i></span>
                        </header>

                    </div>
                    <div class="collapse" id="{{'ABCD' + dataMain.GtcID}}">
                        <div class="mb-3 col-sm-12" *ngFor="let data of dataMain.ClauseDetailsList">
                            <div class="cardSearch">
                                <div class="card-header form-control" data-bs-toggle="collapse"
                                    attr.href="#{{'ABC' + data.ClauseNumber.toString()}}" role="button"
                                    aria-expanded="false"
                                    attr.aria-controls="#{{'ABC' + data.ClauseNumber.toString()}}">
                                    <header class="panel-heading">
                                        <Label class="panel-title">{{"Standard Clause:" + data.ClauseNumber}}
                                        </Label>

                                        &nbsp;
                                        &nbsp;
                                        <span *ngIf="data.ClauseStatus == 1"
                                            style="font-size: medium;color: green;">(Approved)</span>
                                        <span *ngIf="data.ClauseStatus == 2"
                                            style="font-size: medium;color: red;">(Rejected)</span>
                                        <span *ngIf="data.ClauseStatus == 3"
                                            style="font-size: medium;color: darkred;">(Pushback)</span>
                                        <span style="float:right"> <i class="pi pi-arrow-down"></i></span>
                                    </header>
                                </div>
                                <div class="collapse" id="{{'ABC' + data.ClauseNumber.toString()}}">

                                    <div class="rowAltr" style=" pointer-events: none;
                                            opacity: 0.4;margin-left: 10px;margin-bottom: -12px;">
                                        <div class="mb-3 col-md-10">

                                            <div class="input-group radio-div">

                                                <mat-radio-group class="section-c-radio" [(ngModel)]="data.ClauseRadioType">
                                                    <mat-radio-button value="1">Modify Clause</mat-radio-button>
                                                    <mat-radio-button value="2">Delete Clause</mat-radio-button>
                                                    <mat-radio-button value="3">No Change</mat-radio-button>
                                                    <mat-radio-button value="4">Add Clause/Sub Clause</mat-radio-button>
                                                </mat-radio-group>
                                                <!-- <mat-radio-group >
                                                        <mat-radio-button  *ngFor="let clause of clauseTypeList"
                                                            (change)="radioChange($event)"
                                                            [value]="clause.value"
                                                        >
                                                        {{clause.label}}
                    
                                                        </mat-radio-button>
                                                        </mat-radio-group> -->
                                            </div>

                                        </div>
                                    </div>
                                    <div class="row">


                                        <!-- master clause -->
                                        <div style="width: 100%;">
                                            <div class="mb-3 col-md-12 section-c-header">
                                                <div class="section-c-content">
                                                <div class="input-group">
                                                    <label style="font-size:10px;align-self: center;">Proposed Edits by
                                                        Client</label>
                                                    &nbsp;
                                                    <div mat-raised-button
                                                        matTooltip="Changes will appear in track mode in “Modified Clause” section below once you click on Save button">
                                                        <i class="pi pi-question-circle"></i>
                                                    </div>
                                                    &nbsp; &nbsp;

                                                </div>
                                                </div>    
                                            </div>
                                            <div class="section-c-content">
                                                <textarea class="form-control" readonly
                                                    style="resize:none; height: 110px; border-color: black;">{{data.Description}}</textarea>
                                            </div>
                                        </div>

                                        <!-- Changes Proposed By Client -->
                                        <div style="width: 100%;"
                                            *ngIf="data.ClauseRadioType == 1 || data.ClauseRadioType == 4">
                                            <div class="mb-3 col-md-12 section-c-header">
                                                <div class="section-c-content">
                                                <div class="input-group">
                                                    <label style="font-size:10px;align-self: center;">Modified
                                                        Clause</label>
                                                    &nbsp;
                                                    <div mat-raised-button
                                                        matTooltip="Changes will appear automatically once you click on Save button.">
                                                        <i class="pi pi-question-circle"></i>
                                                    </div>
                                                    &nbsp; &nbsp;

                                                </div>
                                                </div>
                                            </div>
                                            <!-- <div class="mb-3 col-md-12">
                                                        <div  class="form-control" style="  margin:5px;
                                                        padding:4px;
                                                        border-radius: 2px solid black;
                                                        height: 110px;
                                                        background-color: rgb(211, 211, 211);
                                                        overflow-x: hidden;
                                                        overflow-y: auto;
                                                        width: min-content;
                                                         min-width: fit-content;
                                                        text-align:justify;" [innerHTML]="data.ProposedByClientDesc">

     
                                                        </div>
                                                    </div> -->
                                            <div class="section-c-content">
                                                <div class="modified-clause-box"
                                                    [innerHTML]="data.ProposedByClientDesc">
                                                </div>
                                            </div>
                                        </div>
                                        <!-- add sub clause -->
                                        <div style="width: 100%;" *ngIf="data.ClauseRadioType == 4">
                                            <div class="mb-3 col-md-12 section-c-header">
                                                <label style="font-size:10px;align-self: center;">Add Clause/Sub
                                                    Clause</label>
                                            </div>
                                            <div class="section-c-content">
                                                <textarea class="form-control" [(ngModel)]="data.SubClauseDec" readonly
                                                    style="resize:none; height: 110px; border-color: black;"></textarea>
                                            </div>
                                        </div>
                                        <!-- GCO Comments on the proposed changes  -->
                                        <div style="width: 100%;"
                                            *ngIf="data.ClauseRadioType == 1 || data.ClauseRadioType == 4 || data.ClauseRadioType == 2 ">
                                            <div class="mb-3 col-md-12 section-c-header">
                                                <div class="section-c-content">
                                                <div class="input-group">
                                                    <label style="font-size:10px;align-self: center;">GCO Comments on
                                                        the proposed changes</label>
                                                    &nbsp;
                                                    <div mat-raised-button
                                                        matTooltip="GCO comments on the proposed change- (Provide reference (page/ para number, document name, email dated etc) to the document with GCO comments).">
                                                        <i class="pi pi-question-circle"></i>
                                                    </div>
                                                    &nbsp; &nbsp;

                                                </div>
                                                </div>
                                            </div>
                                            <div class="section-c-content">
                                                <textarea class="form-control" [(ngModel)]="data.GCOComment" readonly
                                                    style="resize:none; height: 110px; border-color: black;"></textarea>
                                            </div>
                                        </div>
                                        <!--Risk mitigation   -->
                                        <div style="width: 100%;"
                                            *ngIf="data.ClauseRadioType == 1 || data.ClauseRadioType == 4 || data.ClauseRadioType == 2 ">
                                            <div class="mb-3 col-md-12 section-c-header">
                                                <div class="section-c-content">
                                                    
                                                    <div class="input-group">
                                                        <label style="font-size:10px;align-self: center;">Risk Mitigation
                                                            Action Plan <span class="required"
                                                            style="color: red">*</span></label>
                                                        &nbsp;
                                                        <div mat-raised-button
                                                            matTooltip="Risk Mitigation Action Plan - (Engagement teams' comments on the risk mitigation steps to be undertaken to manage increased risk. You may refer to the indicative risk mitigation action plan available in the India Tax Manual">
                                                            <i class="pi pi-question-circle"></i>
                                                        </div>
                                                        &nbsp; &nbsp;

                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            <div class="section-c-content">
                                                <textarea class="form-control" readonly
                                                    [(ngModel)]="data.RiskMitigationActionPlan"
                                                    style="resize:none; height: 110px; border-color: black;"></textarea>
                                            </div>
                                        </div>



                                    </div>
                                    <div class="rowAltr">
                                        <div class="mb-3 col-md-12 section-c-header">
                                            <label>Tax Quality Leader Comments</label>
                                        </div>
                                        <div class="mb-3 col-md-12">
                                            <textarea class="form-control" [(ngModel)]="data.TaxQualityLeaderComments"
                                                style="resize:none; height: 110px; border-color: black;"></textarea>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ng-template #sendTQ_ET>
        <header class="panel-heading" style="margin: 5px;">
            <h5 class="panel-title">Reason for sending back to {{SelectedAction==ReturnByTQLLeader?'Engagement
                Team':'Tax
                Quality Team'}}<span class="required">*</span></h5>
        </header>
        <div class="row" style="margin: 5px;">
            <div class="col-md-12">
                <textarea type="text" class="form-control" maxlength="500" placeholder="" [(ngModel)]="Reason"
                    style="resize:none; height: 110px;"></textarea>
            </div>
        </div>
        <br>
        <footer class="panel-footer" style="margin: 5px;">
            <button class="btn-primary1" mat-stroked-button type="button" (click)="SendBack(SelectedAction)">
                Submit
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button class="btn-primary1" mat-stroked-button type="button" (click)="Cancel()">Cancel</button>
        </footer>
    </ng-template>
</div>